<app-download-app-banner></app-download-app-banner>
<div class="container-fluid">
  <div class="row">
    <app-map [dataset]="dataset" [filter]="mapFilter" [filters]="mapFilters" *isBrowser></app-map>
  </div>
</div>
<div class="container">
  <div class="row breathe">
    <app-data-description [data]="dataDescription"></app-data-description>
  </div>
  <div class="row breathe charts">
    <h2>{{ 'general.descriptions.title.charts' | translate }}</h2>
    @for (extract of extracts; track extract) {
<div class="w-100 mb-5">
      <!--<div class="h-100 pr-3 pb-3 chart-wrapper">-->

      @if (extract.type.toString() == 'DISTRIBUTION') {
<app-chart-distribution [extract]="extract" (updateRequest)="updateExtracts([$event])"></app-chart-distribution>
}
      @if (extract.type.toString() == 'TIMESERIES') {
<app-chart-timeseries [extract]="extract" (updateRequest)="updateExtracts([$event])"></app-chart-timeseries>
}
      @if (extract.type.toString() == 'COMPARISON') {
<app-chart-comparison [extract]="extract" (updateRequest)="updateExtracts([$event])"></app-chart-comparison>
}

      <!--</div>-->
    </div>
}
  </div>
</div>
